import { useTranslation } from 'react-i18next';
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe } from "lucide-react";

export default function LanguageSelector() {
  const { i18n } = useTranslation();

  const changeLanguage = async (lng: string) => {
    // Garante que o bundle do idioma está carregado antes de trocar,
    // evitando o flash sem tradução causado pelo carregamento lazy.
    if (!i18n.hasResourceBundle(lng, 'translation')) {
      const loaders: Record<string, () => Promise<{ default: Record<string, unknown> }>> = {
        en: () => import('@/locales/en.json'),
        es: () => import('@/locales/es.json'),
      };
      if (loaders[lng]) {
        const { default: resources } = await loaders[lng]();
        i18n.addResourceBundle(lng, 'translation', resources, true, true);
      }
    }
    i18n.changeLanguage(lng);
  };

  const languages = [
    { code: 'pt', label: 'Português' },
    { code: 'en', label: 'English' },
    { code: 'es', label: 'Español' }
  ];

  // i18n.language can be "pt-BR", so we use resolvedLanguage or slice to 2 chars
  const activeLang = (i18n.resolvedLanguage || i18n.language || 'pt').slice(0, 2);
  const currentLang = languages.find(l => l.code === activeLang) || languages[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-1.5 px-2">
          <Globe className="h-4 w-4" />
          <span className="text-xs font-medium uppercase">{currentLang.code}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={activeLang === lang.code ? "bg-accent" : ""}
          >
            {lang.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
